import {
    State,
} from './state';
import {
    SourceType,
    Source,
} from 'one-model-local';
// Redux action types
export const ADD = 'one-state-source/add';
export const SET = 'one-state-source/set';
export const RESET = 'one-state-source/reset';
export const REMOVE = 'one-state-source/remove';
export const SELECT = 'one-state-source/select';
export const UNSELECT = 'one-state-source/unselect';

export type SourceState = State<Source>;
export type SourceTypeState = State<SourceType>;
